import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-tab-group',
	templateUrl:'./WaTabGroupPage.html',
	styles: [],
	styleUrls:['./WaTabGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaTabGroupPage
{
	mdContent_464 = `\`\`\`java
import com.jwebmp.webawesome.components.tabgroup.WaTabGroup;
\`\`\``;
	mdContent_465 = `\`\`\`java
new WaTabGroup<>()
\`\`\``;
	mdContent_466 = `\`\`\`java
var tabs = new WaTabGroup<>();
tabs.add(new WaTab<>("General", "general"));
tabs.add(new WaTab<>("Settings", "settings"));
tabs.add(new WaTabPanel<>("general", generalContent));
tabs.add(new WaTabPanel<>("settings", settingsContent));
\`\`\``;
}
